import React from 'react'

import AuthScreen from '@percent/admin-dashboard/common/assets/images/auth_screen.png'
import style from './AuthBackgroundImage.module.scss'

export function AuthBackgroundImage() {
  return <img alt="auth-world-screen" src={AuthScreen} className={style.authBackgroundImage} />
}
